import { AxiosResponse } from 'axios';
import { fetchWithErrorHandling } from '../../services/axios';
import { NFTMetadata, TokenURIExceptions, UserNFT, UserNFTsDto } from '../../types/dto/UserNFTs.dto';
import { INFT } from '../../types/nft';
import { getMetadataImage } from '../../utils/nft';

export const loadNFTsWithMetadata = async (
  data: UserNFTsDto,
  uriExceptionList: TokenURIExceptions,
): Promise<INFT[]> => {
  const allTokens = data.owner?.tokens;
  const promises: Promise<AxiosResponse<NFTMetadata>>[] = [];
  allTokens?.map(async (token) => {
    //if token contract is exception
    if (uriExceptionList[token.contract.id]) {
      //use tokenURI from contract
      promises.push(fetchWithErrorHandling(uriExceptionList[token.contract.id][token.tokenID]));
    } else {
      //use tokenURI from graph query
      promises.push(fetchWithErrorHandling(token.tokenURI));
    }
  });

  const responses = await Promise.allSettled(Object.values(promises));

  return (
    allTokens?.map((token, index) => {
      // if (responses[index]?.status !== 'fulfilled') - catch and log promise rejection
      const metadata = (responses[index] as PromiseFulfilledResult<AxiosResponse<NFTMetadata>>)?.value?.data;
      return {
        id: `${token.tokenID}-${token.contract.id}`,
        contractAddress: token.contract.id.toLowerCase(),
        tokenId: token.tokenID,
        issuer: token.contract.name || token.contract.id,
        name: metadata?.name || token.contract.symbol || getCustomMetadataName(token.contract.id),
        imgUrl: getMetadataImage(metadata) || '',
        description: metadata?.description || getTokenDescription(token),
        amount: token.quantity ?? '0',
      };
    }) || []
  );
};

const getTokenDescription = (token: UserNFT): string => {
  return token.contract.name === `${token.tokenID}` ? '' : `${token.tokenID}`; // prevent same information about tokens
};

export const getCustomMetadataName = (contractAddress: string): string => {
  if (contractAddress.toLowerCase().startsWith('0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85')) {
    // - ENS
    return 'Ethereum Name Service (ENS)';
  }
  return '';
};
